/* ==========================================================================
   Edge Accessories — header
   Search panel + predictive product results.

   The mobile menu panel is Bootstrap's offcanvas, driven by data attributes
   in the markup, so there is nothing to wire up here for it.

   Results come from Shopify's predictive search rendered through the
   Section Rendering API, so this file never has to format a price or build
   a product card — it just swaps in the HTML the server returned.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 250;

  var panel, toggle, input, results, clearBtn;
  var timer = null;
  var controller = null;
  var lastQuery = '';

  /* ------------------------------------------------------------ panel */

  function openPanel() {
    panel.hidden = false;
    // Next frame, so the transition has a start state to animate from.
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();
    });
  }

  function closePanel() {
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');

    var done = function () {
      panel.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    // Fallback if the transition never fires (reduced motion, hidden tab).
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 400);
  }

  function togglePanel() {
    if (panel.hidden) openPanel();
    else closePanel();
  }

  /* --------------------------------------------------------- searching */

  function setBusy(state) {
    results.classList.toggle('is-loading', state);
  }

  function clearResults() {
    results.innerHTML = '';
    results.classList.remove('is-visible');
  }

  function search(query) {
    // Abandon a slower in-flight request so results can't arrive out of order.
    if (controller) controller.abort();
    controller = new AbortController();

    var url = ROOT + 'search/suggest?q=' + encodeURIComponent(query) +
      '&section_id=predictive-search' +
      '&resources[type]=product' +
      '&resources[limit]=6';

    setBusy(true);

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search unavailable');
        return response.text();
      })
      .then(function (html) {
        // The section response is a full document fragment; take its body.
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('.shopify-section') || parsed.body;
        results.innerHTML = section.innerHTML.trim();
        results.classList.add('is-visible');
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        clearResults();
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function onInput() {
    var query = input.value.trim();

    clearBtn.hidden = query.length === 0;

    if (query === lastQuery) return;
    lastQuery = query;

    clearTimeout(timer);

    if (query.length < MIN_CHARS) {
      if (controller) controller.abort();
      clearResults();
      setBusy(false);
      return;
    }

    timer = setTimeout(function () { search(query); }, DEBOUNCE_MS);
  }

  /* -------------------------------------------------------------- init */

  function init() {
    panel = document.getElementById('searchPanel');
    toggle = document.querySelector('[data-search-toggle]');
    if (!panel || !toggle) return;

    input = panel.querySelector('[data-predictive-input]');
    results = panel.querySelector('[data-predictive-results]');
    clearBtn = panel.querySelector('[data-search-clear]');

    toggle.addEventListener('click', togglePanel);
    input.addEventListener('input', onInput);

    clearBtn.addEventListener('click', function () {
      input.value = '';
      lastQuery = '';
      clearBtn.hidden = true;
      clearResults();
      input.focus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel();
        toggle.focus();
      }
    });

    // Clicking away closes the panel, but not when the click is inside it.
    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
